import { AssignedUserBubble } from "@/components/_Shared/AssignedUserBubble";
import { useState } from "react";
import { useMouseCapture } from "@/hooks/useMouseCapture";
import { getColorClass } from "@/components/_Shared/getColorClass";

/**
 * ProgressBar component for displaying progress with customizable appearance
 * 
 * @param label - Text label to display inside the progress bar
 * @param completed - Number of completed items
 * @param total - Total number of items
 * @param barColor - color for the progress bar (e.g., "green")
 * @param width - CSS width class for the container (e.g., "w-1/2")
 */

type ProgressBarProps = {
  label: string;
  completed: number;
  total: number;
  barColor: string;
  width?: string;
  users?: string[];
}

/** TODO: Fix the getColorClass to work with the barBorderColor */
export function ProgressBar({
  label,
  completed,
  total,
  barColor,
  width = "w-1/2",
  users = []
}: ProgressBarProps) {
  // Calculate progress percentage, handling edge cases
  const progressPercentage = 
    completed === 0 && total === 0 
      ? 0 
      : (completed / total * 100)

  const [showUsers, setShowUsers] = useState(false)
  const { mousePosition, handleMouseMove } = useMouseCapture()
  const barBorderColor = barColor.split("-")[1]
  
  return (
    <div 
      className={`h-6 bg-stone-200 dark:bg-stone-700 rounded-full ${width}`}
      onMouseEnter={() => setShowUsers(true)}
      onMouseLeave={() => setShowUsers(false)}
      onMouseMove={handleMouseMove}
    >
      <div 
        className={`${barColor} h-6 rounded-full`} 
        style={{ width: `${progressPercentage}%` }}
      >
        {showUsers && users && <HoverUsers users={users} mouse_position={mousePosition} barBorderColor={barBorderColor} />}
        
        <p className="ml-2 text-nowrap text-stone-900 dark:text-stone-50">
          {label}: {completed} / {total}
        </p>
      </div>
    </div>
  )
} 

function HoverUsers({ users, mouse_position, barBorderColor }: { users: string[], mouse_position: { x: number, y: number }, barBorderColor: string }) {
  return (
    <div className={`flex flex-col gap-2 border fixed bg-stone-50 dark:bg-stone-900 rounded-md shadow-md p-2 text-sm pointer-events-none z-50 ${getColorClass(barBorderColor, 400, "border")}`}
      style={{
        left: `${mouse_position.x + 15}px`,
        top: `${mouse_position.y - 40}px`,
      }}
    >
      <span className="font-semibold text-stone-900 dark:text-stone-50">Assigned Users:</span>
      <div className={`flex flex-wrap gap-2 max-w-[10rem]`}>

        {users && users.length > 0 ? users.map((user, index) => (
          <AssignedUserBubble key={index} user={user} />
        )) : <p className="italic text-stone-900 dark:text-stone-50">(No users assigned)</p>}

      </div>
    </div>
  );
}
